export default () => 'ontouchstart' in window || navigator.maxTouchPoints > 0
